export enum CompatibilityLevel {
  NOT_COMPATIBLE = -1,
  FULL = 1,
  PARTIAL = 2,
}